import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	privateEmail: {
		id: 'servicedesk-customers-organization-common.table.customer-cell.user.private-email',
		defaultMessage: 'private email address',
		description: 'label displayed for private email address',
	},
});
